﻿import { CustomizationDto, UpdateCustomizationDto } from './dtos/customization.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams, HttpEvent, HttpRequest, HttpHeaderResponse, HttpEventType } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { tap, catchError } from "rxjs/operators";

import { environment } from 'environments/environment';
import { ApiResponse } from './api-response-models';
import { AuthUser } from '../+auth/auth.user';
import { AuthToken } from '../+auth/auth.token';
import { Subject } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const API_URL = environment.apiUrl;
const AUTH_API_URL = environment.authApiUrl;

@Injectable()
export class ApiService {
    public unauthorizederror: Subject<any>;

    constructor(public http: HttpClient) {
        this.unauthorizederror = new Subject<any>();
    }

    postAuth(endpoint: string, authUser: AuthUser): Observable<ApiResponse<AuthToken>> {

        // tslint:disable-next-line:max-line-length
        const authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic ' + btoa(authUser.username + ":" + authUser.password) });
        const options = { headers: authHeaders };
        return this.http.post<string>(
            this.getAuthApiUrlFor(endpoint), authUser, options)
            .map<string, ApiResponse<AuthToken>>((res:any) => {
                let response: ApiResponse<AuthToken> = new ApiResponse<AuthToken>();
                response.prepareForNonStandard();

                let token: AuthToken = new AuthToken();
                token.token = res.token;
                token.expiration = res.expiration;
                token.lastLoggedOn = res.lastLoggedOn;

                console.log('map tapped', token);
                response.data = token;
                return response;
            })
            .pipe(
                tap(t => this.log('auth post tapped'))
                //,catchError(this.handleApiError<T>(endpoint))
            );
    }

    postChangePwd(endpoint: string, authUser: AuthUser): Observable<ApiResponse<any>> {
        // tslint:disable-next-line:max-line-length
        const authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic ' + btoa(authUser.username + ":" + authUser.password) });
        const options = { headers: authHeaders };
        return this.http.post<string>(
            this.getAuthApiUrlFor(endpoint), authUser, options)
            .map<string, ApiResponse<AuthToken>>((res: any) => {
                return res;
            })
            .pipe(
                tap(t => this.log('changepwd post tapped'))
            );
    }

    postNewPwd(endpoint: string, username: string, password: string, newpassword: string): Observable<ApiResponse<AuthToken>> {
        const authHeaders = new HttpHeaders({ 
            'Content-Type': 'application/json', 
            'Authorization': 'Basic ' + btoa(username + ":" + password),
            'NewPassword': newpassword
        });

        const options = { headers: authHeaders };
        return this.http.post<string>(
            this.getAuthApiUrlFor(endpoint), {}, options)
            .map<string, ApiResponse<AuthToken>>((res:any) => {
                return res;
            })
            .pipe(
                tap(t => this.log('auth post tapped'))
                //,catchError(this.handleApiError<T>(endpoint))
            );
    }

    post<T>(endpoint: string, postData: any, options?:any): Observable<ApiResponse<T>> {
        let postOptions = httpOptions;
        if (options) postOptions = options;

        return this.http.post<ApiResponse<T>>(
            this.getApiUrlFor(endpoint), postData, postOptions)
            .pipe(
                tap(t => this.log('post tapped')),
                catchError(this.handleApiError<T>(endpoint))
            );
    }

    // file from event.target.files[0]
    uploadFile(url: string, file: File): Observable<HttpEvent<any>> {

        let formData = new FormData();
        formData.append('image', file);

        let params = new HttpParams();

        const options = {
            params: params,
            reportProgress: true,
        };

        const req = new HttpRequest('POST', this.getApiUrlFor('documents'), formData, options);
        return this.http.request(req);
    }

    uploadImportedFile(file: File): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        const req = new HttpRequest('POST', this.getApiUrlFor('inventory'), formData, options);
        return this.http.request(req);
    }

    uploadCustomizationFile(programId, customizationData: UpdateCustomizationDto, file: File): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('CustomizaitonEntry', customizationData.CustomizaitonEntry);
        formData.append('CustomizationDisplayOptionId', customizationData.CustomizationDisplayOptionId.toString());
        formData.append('CustomizProgramTacticIdaitonEntry', customizationData.ProgramTacticId.toString());
        formData.append('CustomizationRequestId', customizationData.CustomizationRequestId.toString());

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        const req = new HttpRequest('POST', this.getApiUrlFor(`programs/${programId}/customizations`), formData, options);
        return this.http.request(req);
    }

    uploadCustomizationFilePromise(programId, customizationData: UpdateCustomizationDto, file: File): Promise<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('CustomizaitonEntry', customizationData.CustomizaitonEntry);

        if (customizationData.CustomizationDisplayOptionId)
            formData.append('CustomizationDisplayOptionId', customizationData.CustomizationDisplayOptionId.toString());
        
        formData.append('ProgramTacticId', customizationData.ProgramTacticId.toString());
        formData.append('CustomizationRequestId', customizationData.CustomizationRequestId.toString());
        
        if(customizationData.MappingFields)
            formData.append('mappingFieldsString', JSON.stringify(customizationData.MappingFields));

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };
        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('PUT', encodeURI(this.getApiUrlFor(`programs/${programId}/customizations/uploadfile`)), formData, options);
        return new Promise((resolve, reject) => {
            this.http.request(req).subscribe(event => {
                // progress
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log(event.loaded, event.total); 
                    const percentage = 100 / event.total * event.loaded;
                    console.log(percentage);
                }

                // finished
                if (event.type === HttpEventType.Response) {
                    resolve(event);
                }
            });
        })
    }

    uploadShippingLocations(file: File, programid: number, deliveryDate: string = null, deliveryNotes = '', saveToAddressBook = false): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programs/${programid}/import-shipping-location?deliveryDate=${deliveryDate}&deliveryNotes=${deliveryNotes}&saveToAddressBook=${saveToAddressBook}`)), formData, options);
        return this.http.request(req);
    }

    uploadComponentFile(file: File, programid: number, componentId: number): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programtactics/component/${componentId}/upload?programId=${programid}`)), formData, options);
        return this.http.request(req);
    }

    uploadComponentFilePromise(file: File, programid: number, componentId: number): Promise<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programtactics/component/${componentId}/upload?programId=${programid}`)), formData, options);
        return new Promise((resolve, reject) => {
            this.http.request(req).subscribe(event => {
                // progress
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log(event.loaded, event.total); 
                    // event.loaded = bytes transfered 
                    // event.total = "Content-Length", set by the server
                    const percentage = 100 / event.total * event.loaded;
                    console.log(percentage);
                }

                // finished
                if (event.type === HttpEventType.Response) {
                    resolve(event);
                }
            });
        })
    }

    uploadProgramTacticFile(file: File, programid: number, programTacticId: number): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programs/programtactic/${programTacticId}/upload?programId=${programid}`)), formData, options);
        return this.http.request(req);
    }

    uploadProgramTacticFilePromise(file: File, programid: number, programTacticId: number): Promise<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programs/programtactic/${programTacticId}/upload?programId=${programid}`)), formData, options);
        return new Promise((resolve, reject) => {
            this.http.request(req).subscribe(event => {
                // progress
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log(event.loaded, event.total); 
                    // event.loaded = bytes transfered 
                    // event.total = "Content-Length", set by the server
                    const percentage = 100 / event.total * event.loaded;
                    console.log(percentage);
                }

                // finished
                if (event.type === HttpEventType.Response) {
                    resolve(event);
                }
            });
        })
    }

    uploadCommunicationRequestFile(file: File, programid: number, communicationRequestId: number, versionId: number = 1): Promise<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programs/communicationrequest/${communicationRequestId}/upload?programId=${programid}&versionId=${versionId}`)), formData, options);
        return new Promise((resolve, reject) => {
            this.http.request(req).subscribe(event => {
                // progress
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log(event.loaded, event.total); 
                    // event.loaded = bytes transfered 
                    // event.total = "Content-Length", set by the server
                    const percentage = 100 / event.total * event.loaded;
                    console.log(percentage);
                }

                // finished
                if (event.type === HttpEventType.Response) {
                    resolve(event);
                }
            });
        })
    }

    uploadCommunicationRequestMessageFile(file: File, programid: number, communicationRequestId: number, messageId: number, versionId: number = 1): Promise<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`programs/communicationrequest/${communicationRequestId}/upload/messagefiles/${messageId}?programId=${programid}&versionId=${versionId}`)), formData, options);
        return new Promise((resolve, reject) => {
            this.http.request(req).subscribe(event => {
                // progress
                if (event.type === HttpEventType.DownloadProgress) {
                    console.log(event.loaded, event.total); 
                    // event.loaded = bytes transfered 
                    // event.total = "Content-Length", set by the server
                    const percentage = 100 / event.total * event.loaded;
                    console.log(percentage);
                }

                // finished
                if (event.type === HttpEventType.Response) {
                    resolve(event);
                }
            });
        })
    }

    uploadTacticFile(file: File, tacticId: number): Observable<HttpEvent<any>> {

        const formData = new FormData();
        formData.append('file', file);

        const params = new HttpParams();
        const options = {
            params: params,
            reportProgress: true,
        };

        // tslint:disable-next-line:max-line-length
        const req = new HttpRequest('POST', encodeURI(this.getApiUrlFor(`tactics/${tacticId}/upload-file`)), formData, options);
        return this.http.request(req);
    }

    put<T>(endpoint: string, postData: any): Observable<ApiResponse<T>> {
        return this.http.put<ApiResponse<T>>(
            this.getApiUrlFor(endpoint), postData, httpOptions)
            .pipe(
                tap(t => this.log('post tapped')),
                catchError(this.handleApiError<T>(endpoint))
            );
    }

    get<T>(endpoint: string, params?: any, headers?: HttpHeaders): Observable<ApiResponse<T>> {
        return this.http.get<ApiResponse<T>>(
            this.getApiUrlFor(endpoint), { params: this.getApiParamsFor(params), headers:  headers})
            .pipe(
                tap(t => this.log(`get tapped`)),
                catchError(this.handleApiError<T>(endpoint))
            );
    }

    delete<T>(endpoint: string): Observable<ApiResponse<T>> {
        return this.http.delete<ApiResponse<T>>(
            this.getApiUrlFor(endpoint))
            .pipe(
                tap(t => this.log(`delete get tapped`)),
                catchError(this.handleApiError<T>(endpoint))
            );
    }

    getDownloadUrlFor(documentId: number) {
        let url = `${API_URL}/documents/${documentId}/file`;
        this.log(`getDownloadUrlFor > ${url}`);
        return url;
    }

    public getUrlForUpload(endpoint: string) {
        return this.getApiUrlFor(endpoint);
    }

    public getApiUrlFor(endpoint: string) {
        let url = `${API_URL}/${endpoint}`;
        this.log(`getApiUrlFor > ${url}`);
        return url;
    }

    private getAuthApiUrlFor(endpoint: string) {
        let url = `${AUTH_API_URL}/${endpoint}`;
        this.log(`getAuthApiUrlFor > ${url}`);
        return url;
    }

    private getApiParamsFor(params?: any): HttpParams {
        let httpParams = new HttpParams();
        if (params) {
            for (let p in params) {
                console.log('params: ', params[p]);
                httpParams = httpParams.append(p, params[p]);
            }
        }
        return httpParams;
    }

    /**
    * Handle Http operation that failed.
    * Let the app continue.
    * @param operation - name of the operation that failed
    * @param result - optional value to return as the observable result
    */
    private handleApiError<T>(endpoint = '') {
        return (err: HttpErrorResponse): Observable<ApiResponse<T>> => {
            this.log(`Error encountered at endpoint ${endpoint}`)
            let response = new ApiResponse<T>();
            // A client-side or network error occurred. Handle it accordingly.
            if (err instanceof Error) {
                response.addKey("")
                    .addError("Network/client error occured");

                this.log(`A network/client error occurred: ${err.error.message}`);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                this.log(`Backend returned code ${err.status}`);
                if (err.status == 400) {//bad request expect body
                    try {
                        response = err.error;
                    } catch (er) {
                        response.addKey("")
                            .addError("Server did not format the body properly. Internal error.");
                    }
                }
                else if (err.status == 401) {//unauthorized
                    //for other services this is a redirect to 401
                    response.addKey("").addError("Login failed. Try again.");
                    this.unauthorizederror.next();
                } else if (err.status == 403) {//forbidden
                    //for all redirect to 403
                    response.addKey("")
                        .addError("Login failed. Try again.");
                }
            }

            //so far no error written. Force one.
            if (!response.hasError)
                response.addKey("")
                    .addError("Server returned undecodable error.");

            return of(response);
        }
    }

    private log(message: string) {
        //this.messageService.add('HeroService: ' + message);        
        console.log('Message received: ', message);
    }

    private createErrorResponse<T>(error: string): ApiResponse<T> {
        // Let the app keep running by returning an empty result.
        let result = new ApiResponse<T>();
        result.addKey("")
            .addError(error || 'Unknown client error occured');

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/client-core/api.service.ts